/**
 * 将驼峰格式的字符串转为破折号分割的小写字符串
 * @param {String} content
 */
export function capitalToDash(content: string): string {
  const chars = [];
  for (let i = 0; i < content.length; i++) {
    let char: string = content[i];
    const charCode = char.charCodeAt(0);
    if (charCode >= 65 && charCode <= 90) {
      char = `-${char.toLowerCase()}`;
    }
    chars.push(char);
  }
  return chars.join('');
}

/**
 * 生成简易随机 id
 *
 * @see https://gist.github.com/SimonHoiberg/ad2710c8626c5a74cddd8f6385795cc0
 */
export function uid() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
}
